// Adele Songs - Ranked by Chart Performance & Streaming Popularity
// Difficulty: DIFFICULT - Music chart knowledge required

export const adeleSongsData = [
  { id: 1, name: "Someone\nLike You", rank: 1, image: "/images/adele/someone_like_you.png" },
  { id: 2, name: "Hello", rank: 2, image: "/images/adele/hello.png" },
  { id: 3, name: "Rolling in\nthe Deep", rank: 3, image: "/images/adele/rolling_in_the_deep.png" },
  { id: 4, name: "Easy\nOn Me", rank: 4, image: "/images/adele/easy_on_me.png" },
  { id: 5, name: "Set Fire\nto the\nRain", rank: 5, image: "/images/adele/set_fire_to_the_rain.png" },
  { id: 6, name: "When We\nWere\nYoung", rank: 6, image: "/images/adele/when_we_were_young.png" },
  { id: 7, name: "Make You\nFeel My\nLove", rank: 7, image: "/images/adele/make_you_feel_my_love.png" },
  { id: 8, name: "Chasing\nPavements", rank: 8, image: "/images/adele/chasing_pavements.png" },
  { id: 9, name: "Skyfall", rank: 9, image: "/images/adele/skyfall.png" },
  { id: 10, name: "All I Ask", rank: 10, image: "/images/adele/all_i_ask.png" },
  { id: 11, name: "Water\nUnder the\nBridge", rank: 11, image: "/images/adele/water_under_the_bridge.png" },
  { id: 12, name: "Send My\nLove", rank: 12, image: "/images/adele/send_my_love.png" },
  { id: 13, name: "Rumour\nHas It", rank: 13, image: "/images/adele/rumour_has_it.png" },
  { id: 14, name: "Turning\nTables", rank: 14, image: "/images/adele/turning_tables.png" },
  { id: 15, name: "Hometown\nGlory", rank: 15, image: "/images/adele/hometown_glory.png" },
  { id: 16, name: "Lovesong", rank: 16, image: "/images/adele/lovesong.png" },
  { id: 17, name: "One and\nOnly", rank: 17, image: "/images/adele/one_and_only.png" },
  { id: 18, name: "Remedy", rank: 18, image: "/images/adele/remedy.png" },
  { id: 19, name: "Million\nYears Ago", rank: 19, image: "/images/adele/million_years_ago.png" },
  { id: 20, name: "Don't You\nRemember", rank: 20, image: "/images/adele/dont_you_remember.png" },
  { id: 21, name: "Hold On", rank: 21, image: "/images/adele/hold_on.png" },
  { id: 22, name: "Oh My\nGod", rank: 22, image: "/images/adele/oh_my_god.png" },
  { id: 23, name: "I Drink\nWine", rank: 23, image: "/images/adele/i_drink_wine.png" },
  { id: 24, name: "Cry Your\nHeart Out", rank: 24, image: "/images/adele/cry_your_heart_out.png" },
  { id: 25, name: "To Be\nLoved", rank: 25, image: "/images/adele/to_be_loved.png" },
  { id: 26, name: "Love in\nthe Dark", rank: 26, image: "/images/adele/love_in_the_dark.png" },
  { id: 27, name: "Sweetest\nDevotion", rank: 27, image: "/images/adele/sweetest_devotion.png" },
  { id: 28, name: "River Lea", rank: 28, image: "/images/adele/river_lea.png" },
  { id: 29, name: "Cold\nShoulder", rank: 29, image: "/images/adele/cold_shoulder.png" },
  { id: 30, name: "Crazy\nfor You", rank: 30, image: "/images/adele/crazy_for_you.png" },
];
